import { useMemo, useState } from "react";
import styled from "styled-components";
import SortableTable from "../../../Componentes/Utils/SortableTable";

const PageContent = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;
    box-sizing: border-box;
    overflow: hidden;
`;

const TableFlexFill = styled.div`
    flex: 1;
    min-height: 0;
    width: 100%;
    display: flex;
    flex-direction: column;

    & > div {
        flex: 1;
        min-height: 0;
        display: flex;
        flex-direction: column;
    }
`;

const Content = () => {

    // TODO: buscar a lista de PROSSMAPs na API quando o endpoint existir
    const [loading] = useState(false);
    const [prossmaps] = useState([]);

    const columns = useMemo(
        () => [
            {
                id: "id",
                header: "ID",
                accessor: "id",
                sortable: true,
                width: "70px",
                align: "center",
            },
            {
                id: "equipe",
                header: "EQUIPE",
                accessor: "equipe",
                sortable: true,
            },
            {
                id: "encarregado",
                header: "ENCARREGADO",
                accessor: "encarregado_nome",
                sortable: true,
            },
            {
                id: "matricula",
                header: "MATRÍCULA",
                accessor: "encarregado_matricula",
                sortable: true,
                width: "110px",
            },
            {
                id: "referencia",
                header: "MÊS REFERÊNCIA",
                accessor: "referencia_mes",
                sortable: true,
                width: "140px",
                align: "center",
            },
            {
                id: "pontos",
                header: "PONTOS",
                accessor: "pontos_obtidos",
                sortable: true,
                width: "100px",
                align: "center",
            },
            {
                id: "status",
                header: "STATUS",
                accessor: "status",
                sortable: true,
                width: "140px",
            },
        ],
        []
    );

    return (
        <PageContent>
            <TableFlexFill>
                <SortableTable
                    columns={columns}
                    data={prossmaps}
                    isLoading={loading}
                    loadingText="Carregando PROSSMAPs..."
                    emptyText="Nenhum PROSSMAP encontrado."
                    initialSort={{ key: "referencia", direction: "desc" }}
                    getRowId={(row) => row.id}
                />
            </TableFlexFill>
        </PageContent>
    );
};

export default Content;
